export default {
  privacy: 'https://www.remeha.nl/professional/algemeen/privacy-policy',
  terms: 'https://remeha.be/fr/a-propos-de-remeha/informations-generales/conditions-d-utilisation/',
};



// WEBPACK FOOTER //
// ./js/lang/fr/links.js